import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createStandardAction } from 'typesafe-actions';
import { getAuthState, parseJwt, getAllocationMap, getSubscriptionStatus, getCookieDomain } from '../util/helpers';
import isProduction from '../standalone/isProduction';
import { initializeWtaClient } from '../analytics/wtaAnalytics';
import { productMap, getViewContext } from '../analytics/helpers';
import { OWL } from '../types';
import { getJwt, clearJwt, clearLegacyCookie } from '../util/jwtLocalstorage';
import { googleApiInitialized } from './dependencies';
import wfeTokenRefresh from '../util/wfeTokenRefresh';
import { getOrSetVCookie } from '../util/getVCookie';
import { getExpCookie } from '../util/getExpCookie';
import { uploadReset } from './upload';
import { captureError } from '../util/errors';
export var ActionTypes = {
  PAGE_VIEW: 'PAGE_VIEW',
  APP_INITIALIZING: 'APP_INITIALIZING',
  APP_INITIALIZED: 'APP_INITIALIZED'
};
export var pageView = createStandardAction(ActionTypes.PAGE_VIEW)();
var getLogEventLambdaEndPoint = function getLogEventLambdaEndPoint() {
  return isProduction() ? 'https://analytics.chegg.com/rio-service-web/rest/rio-events/batch' : 'https://analytics.test.cheggnet.com/rio-service-web/rest/rio-events/batch';
};
export var initializeAnalytics = function initializeAnalytics(cookieDomain, viewName) {
  var token = getJwt();
  if (token) {
    var parsedToken = parseJwt(token);
    var cheggUserUuid = parsedToken.cheggUserUuid,
      site = parsedToken.site,
      paidMember = parsedToken.paidMember;
    if (site === OWL) return;
    initializeWtaClient({
      endpoint: getLogEventLambdaEndPoint(),
      authState: getAuthState(cheggUserUuid),
      cheggUuid: cheggUserUuid || undefined,
      property: site,
      appId: 'wfe',
      testCells: getAllocationMap(),
      uvn: getOrSetVCookie(cookieDomain) || undefined,
      clientExperiments: getExpCookie(),
      subscriptions: [{
        product: productMap[site],
        status: getSubscriptionStatus(paidMember)
      }],
      errorHandler: captureError,
      view: getViewContext(site, viewName)
    });
  }
};
export var initializeConfiguration = function initializeConfiguration(viewName) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, _ref) {
      var gapi, _getState, authApiUrl, site, onAuthUpdate, _getState$app, pasteOnly, initRSW, initFreshToken;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            gapi = _ref.gapi;
            _getState = getState(), authApiUrl = _getState.authApiUrl, site = _getState.site, onAuthUpdate = _getState.onAuthUpdate, _getState$app = _getState.app, pasteOnly = _getState$app.pasteOnly, initRSW = _getState$app.initRSW, initFreshToken = _getState$app.initFreshToken;
            dispatch({
              type: ActionTypes.APP_INITIALIZING
            });
            clearLegacyCookie(site);
            _context.prev = 4;
            if (pasteOnly) {
              _context.next = 11;
              break;
            }
            _context.next = 8;
            return gapi.init();
          case 8:
            _context.next = 10;
            return gapi.onApiLoad();
          case 10:
            dispatch(googleApiInitialized());
          case 11:
            if (!initFreshToken) {
              _context.next = 15;
              break;
            }
            clearJwt();
            _context.next = 15;
            return wfeTokenRefresh(authApiUrl, undefined, onAuthUpdate);
          case 15:
            _context.next = 20;
            break;
          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](4);
            captureError(new Error("Error in app initialization: ".concat(JSON.stringify(_context.t0))));
          case 20:
            dispatch({
              type: ActionTypes.APP_INITIALIZED
            });
            if (initRSW) {
              dispatch(pageView({
                viewName: viewName
              }));
              initializeAnalytics(getCookieDomain(site), viewName);
            }
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 17]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var resetUploadingState = function resetUploadingState() {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, _, _ref3) {
      var pusherClient;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            pusherClient = _ref3.pusherClient;
            if (pusherClient) {
              pusherClient.unsubscribe();
            }
            dispatch(uploadReset());
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x4, _x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var resetAndInitialize = function resetAndInitialize() {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            dispatch(resetUploadingState());
            dispatch(initializeConfiguration());
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x7) {
      return _ref5.apply(this, arguments);
    };
  }();
};